module.exports = __webpack_public_path__ + "assets/b1fd9b89b4d21f5b05d9392389e5200f.png";